import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { useAppSelector } from "redux/hooks";
import { deleteAllSelectedRules, selectLensEditorLensId, selectSelectedRules } from "redux/slices/lensEditor";
import { P } from "theme/typography";

export interface BulkDeleteDialogProps {
  open: boolean;
  close: () => void;
}

const BulkDeleteDialog = (props: BulkDeleteDialogProps) => {
  const selectedRules = useAppSelector(selectSelectedRules);
  const ruleCount = selectedRules.length;
  const lensId = useAppSelector(selectLensEditorLensId);
  const snackpatch = useAppDispatchWithSnackbar();

  const runDelete = async () => {
    snackpatch(deleteAllSelectedRules({ lensId }), {
      successMessage: "Rules deleted",
      errorMessage: "Unable to delete rules",
    }).then(() => {
      props.close();
    });
  };

  return (
    <Dialog open={props.open} onClose={props.close}>
      <DialogTitle>Bulk Delete Lens Rules</DialogTitle>
      <DialogContent>
        <P>Are you sure you want to delete these rules? This action cannot be undone.</P>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.close}>Cancel</Button>
        <Button variant="contained" onClick={runDelete}>
          Delete {ruleCount} Rules
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkDeleteDialog;
